import { constrain } from 'baye'

import { FREQUENCE_RANGE } from '@/therapy/constants/sight'

const sight = {
  namespaced: true,
  state: {
    viewMode: 'both', // (默认both)， OD, OS,
    baseAcuity: 1, // 基准视标大小[0.1-1.0]
    OD: {
      relativeAcuity: 100, // 相对大小 ±5%
      frequence: 0,
      sensitivity: '',
      blur: '',
      brightness: '',
      background: '', // 背景选择，普通，空白，黑白格，后像， 红黄
    },
    OS: {
      relativeAcuity: 100,
      frequence: 0,
      sensitivity: '',
      blur: '',
      brightness: '',
      background: '',
    },
  },
  mutations: {
    UPDATE_SIGHT: (state, config) => {
      state = config
      // Object.assign(state.sight, config)
    },
    switchViewMode: state => {
      let arr = ['both', 'OD', 'OS']
      let index = arr.indexOf(state.viewMode)
      index = index > 1 ? 0 : index + 1
      state.viewMode = arr[index]
    },

    /**
     * 成像相关
     */
    updateBaseAcuity: (state, step) => {
      const newValue = constrain(state.baseAcuity + step, 0.1, 1) * 1
      state.baseAcuity = newValue
    },
    setBaseAcuity: (state, value) => {
      state.baseAcuity = value
    },
    updateFrequenceToValue: (state, obj) => {
      state.sight = obj
    },
    setODFrequence: (state) => {
      state.OD.frequence === 0 ? state.OD.frequence = 5 : state.OD.frequence = 0
    },
    setOSFrequence: (state) => {
      state.OS.frequence === 0 ? state.OS.frequence = 5 : state.OS.frequence = 0

    },
    updateFrequence: (state, step) => {
      let mode = state.viewMode === 'OS' ? 'OS' : 'OD'
      const newValue = state[mode].frequence + step
      newValue.toFixed(2)

      if (state.viewMode === 'both') {
        state.OD.frequence = constrain(
          newValue,
          FREQUENCE_RANGE[0],
          FREQUENCE_RANGE[1]
        )
        state.OS.frequence = constrain(
          newValue,
          FREQUENCE_RANGE[0],
          FREQUENCE_RANGE[1]
        )
      } else {
        state[state.viewMode].frequence = constrain(
          newValue,
          FREQUENCE_RANGE[0],
          FREQUENCE_RANGE[1]
        )
      }
    },
    DECREASE_SIGHT_FREQUENCE: state => {
      let newValue = state.frequence - 0.01
      newValue.toFixed(2)
      state.OD.frequence = constrain(newValue, 0.1, 1)
      state.OS.frequence = constrain(newValue, 0.1, 1)
    },
  },
  actions: {},
  getters: {},
}

export default sight
